!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.container = this.querySelector("[data-slider]"), this.productIds = this.dataset.productIds, 
      this.apiKey = this.dataset.apiKey, this.limit = "12", this.hideQuickAdd = "true" === this.dataset.hideQuickAdd;
    }
    connectedCallback() {
      this.container && this.productIds && this.apiKey && this.loadSimilarProducts();
    }
    async loadSimilarProducts() {
      try {
        const t = new URLSearchParams({
          shopify_product_ids: this.productIds,
          limit: this.limit,
          key: this.apiKey,
          format: "pretty"
        }), s = await fetch(`https://rebuyengine.com/api/v1/products/similar_products?${t}`);
        if (!s.ok) throw new Error(`HTTP error! status: ${s.status}`);
        const i = await s.json();
        if (i.data && i.data.length > 0) {
          const t = i.data.map(t => this.loadProduct(t));
          await Promise.all(t);
          const s = this.querySelector("vanilla-slider");
          s && "function" == typeof s.update && s.update(), document.dispatchEvent(new CustomEvent("similar-products:loaded", {
            detail: {
              productCount: i.data.length
            }
          }));
        }
      } catch (t) {
        console.warn("Could not load Rebuy similar products:", t);
      }
    }
    show() {
      this.classList.remove("hidden");
    }
    async loadProduct(t) {
      try {
        const s = this.hideQuickAdd ? "card-no-quick-add" : "card", i = await fetch(`${Shopify.routes.root || "/"}products/${t.handle}?view=${s}`);
        if (!i.ok) throw new Error(i.statusText);
        const e = await i.text(), a = (new DOMParser).parseFromString(e, "text/html"), d = document.createElement("div");
        d.classList.add("slide", "slide--similar"), d.setAttribute("data-slide", !0), d.innerHTML = a.body.innerHTML, 
        this.container.appendChild(d), this.show();
      } catch (s) {
        console.warn("Could not load Rebuy product: " + t.handle + ". " + s);
      }
    }
  }
  customElements.get("similar-products") || customElements.define("similar-products", t);
}();